<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import api from '@/api/'
import storage from '@/utils/storage'

export default {
  name: 'App',
  created() {
    // 加载分类
    api.getData('index/typeList')
      .then((res) => {
        storage.setItem('type', res.data.data)
      })
      .catch((error) => {
        console.log(error)
      })
    // 加载推荐文章
    api.getData('index/openArticleList')
      .then((res) => {
        storage.setItem('openArticleList', res.data.data)
      })
      .catch((error) => {
        console.log(error)
      })
    // 站点配置
    api.getData('index/config', { id: 1 })
      .then((res) => {
        storage.setItem('config', res.data.data)
      })
      .catch((error) => {
        console.log(error)
      })
    // 赞助
    api.getData('index/bannerList', { type: -1 })
      .then((res) => {
        storage.setItem('ad', res.data.data)
      })
      .catch((error) => {
        console.log(error)
      })
  }
}
</script>

<style>
@import '../public/static/fonts/fonts.css';
@import '../public/static/css/css2.css';

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background: #fff;
  font-size: 14px;
  color: #203656;
  font-family: "Poppins", sans-serif, Helvetica, Arial, "Open Sans", Arial, 'PingFang SC', 'Hiragino Sans GB', 'Source Han Sans CN', Roboto, 'Microsoft Yahei';
}

#app {
  min-height: 100vh;
}
</style>

